export const POINTS_SECTIONS = [
  {
    id: "searches",
    title: "Search Results",
    visible: false,
    // contentComp: "searches_comp",
    mapLayerMetadata: "seerist-points-searches",
  },
  {
    id: "hotspots",
    title: "Hotspots",
    visible: false,
    // contentComp: "hotspots_comp",
    mapLayerMetadata: "seerist-points-hotspots",
  },
  {
    id: "my_incidents",
    title: "My Incidents",
    visible: false,
    // contentComp: "my_incidents_comp",
    mapLayerMetadata: "seerist-points-incidents",
  },
  {
    id: "places",
    title: "Places",
    visible: false,
    // contentComp: "places_comp", // Should we skip this section as it is in assets?
    mapLayerMetadata: "seerist-points-places",
  },
  {
    id: "assets",
    title: "Assets",
    visible: false,
    // contentComp: "assets_comp",
    mapLayerMetadata: "seerist-points-assets",
  },
];

export const OVERLAYS_SECTIONS = [
  {
    id: "risk_ratings",
    title: "Risk Ratings",
    // contentComp: "risk_ratings_comp",
    mapLayerMetadata: "seerist-overlays-risk-ratings", // layer.source === "mapbox-terrain"
  },
  {
    id: "pulse",
    title: "Pulse",
    // contentComp: "StabilitySelector",
    mapLayerMetadata: "seerist-overlays-pulse", // layer["source-layer"].indexOf("Pulse") >= 0
  },
  {
    id: "power_outage",
    title: "Power Outage",
    // contentComp: "power_outage_comp",
    mapLayerIds: ["layer-powerOutage"],
    mapLayerMetadata: "seerist-overlays-power-outage",
  },
];
